import React, { Component } from "react";
import PropTypes from "prop-types";
import { fetchFormats } from "../../_actions/slidePresetActions";
import { connect } from "react-redux";
import {
  fetchViewAllTemplatesByGroup,
  resetTemplatesViewAll,
} from "../../_actions/storiesActions";
import axios from "axios";
import { withTranslation } from "react-i18next";
import { Flex, Input, InputGroup, InputLeftElement, InputRightElement } from "@chakra-ui/react";
import { FaArrowLeft, FaSearch, FaTimesCircle } from "react-icons/fa";
import _ from "lodash";

class TLDRTitleSearch extends Component {
  signal = axios.CancelToken.source();
  constructor(props) {
    super(props);

    this.searchTimeInterval = 500;
    this.search = this.search.bind(this);
    this.throttledSearch = _.debounce(this.search, this.searchTimeInterval);
  }

  componentDidMount() { }

  render() {
    const {
      t,
      placeholder,
      searchText,
      goBack,
      leftIcon,
      extraSx,
    } = this.props;

    return (
      <>
        <Flex
          align="center"
          px="0.75rem"
          sx={{
            ...extraSx,
            minHeight: "3.5rem",
            width: "100%"
          }}
        >
          <Flex
            direction="row"
            align="center"
            sx={{
              backgroundColor: "black",
              borderRadius: "8px",
              border: "1px solid",
              borderColor: "whiteAlpha.400",
              width: "100%",
            }}
          >
            <InputGroup>
              <InputLeftElement
                children={leftIcon
                  ? <FaArrowLeft />
                  : <FaSearch />
                }
                onClick={() => {
                  if (goBack) {
                    goBack();
                  }
                }}
              />
              <Input
                placeholder={placeholder}
                onFocus={(text) => this.handleSearchOnFocus(text)}
                onChange={(e) => this.onSearchTextChange(e.target.value)}
                value={searchText}
              />
              {searchText?.length > 0 ? (
                <InputRightElement>
                  <FaTimesCircle
                    onClick={this.handleSearchClear}
                  />
                </InputRightElement>
              ) : null}
            </InputGroup>
          </Flex>
        </Flex>
      </>
    );
  }

  onSearchTextChange = (value) => {
    var searchText = value; // this is the search text

    this.throttledSearch(searchText);
  };

  handleSearchOnFocus = (text) => {
    const { onFocus } = this.props.searchConfig;

    if (onFocus) {
      onFocus(text);
    }
  };

  search = (searchText) => {
    const { handleSearch } = this.props.searchConfig;

    if (handleSearch) {
      handleSearch(searchText);
    }
  };

  handleSearchOnBlur = (text) => {
    const { onBlur } = this.props.searchConfig;

    if (onBlur) {
      onBlur(text);
    }
  };

  handleSearchClear = () => {
    const { onClear } = this.props.searchConfig;

    if (onClear) {
      onClear("");
    }
  };
}

TLDRTitleSearch.defaultProps = {
  page: 1,
  placeholder: "Search anything",
  extraSx: {},
};

TLDRTitleSearch.propTypes = {
  page: PropTypes.number.isRequired,
  slidePresets: PropTypes.object.isRequired,
  extraSx: PropTypes.object,
};

const mapStateToProps = (state) => ({
  slidePresets: state.slidePresets,
  page: state.slidePresets.page,
});

const mapDispatchToProps = (dispatch) => ({
  fetchFormats: (key, props) => dispatch(fetchFormats(key, props)),
  resetTemplatesViewAll: () => dispatch(resetTemplatesViewAll()),
  fetchViewAllTemplatesByGroup: (
    searchTerm,
    formatId,
    categoryId,
    pageIndex,
    props,
    signalToken,
    storyType
  ) =>
    dispatch(
      fetchViewAllTemplatesByGroup(
        searchTerm,
        formatId,
        categoryId,
        pageIndex,
        props,
        signalToken,
        storyType
      )
    ),
});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(TLDRTitleSearch)
);
